import { CF_ASSET_PATH } from "utilities/constants";
import { CfDoubleContentBgBlockProps } from "../types";
import {
  convertCfAlignItemsProps,
  convertCfJustifyContentProps,
} from "utilities/cfPropTypes/cfFlex";
import {
  convertCfBackgroundPosition,
  convertCfBackgroundProps,
  convertCfBackgroundSize,
} from "utilities/cfPropTypes/cfBackground";
import { convertCfSpacersProps } from "utilities/cfPropTypes/cfSpacers";
import { getDeepVal } from "utilities/utils";
import DoubleContentBgBlock from "..";
import React from "react";

export const convertCfDoubleContentBgBlockProps = ({
  doubleContentStyle,
  imageBg,
  imageBgPosition,
  imageBgSize,
  reverse = false,
  children,
}: CfDoubleContentBgBlockProps) => {
  return {
    imageBgMobile: getDeepVal(imageBg, `[0].imageMobile.${CF_ASSET_PATH}`),
    imageBgDesktop: getDeepVal(imageBg, `[0].imageDesktop.${CF_ASSET_PATH}`),
    imageBgPosition: convertCfBackgroundPosition(imageBgPosition),
    imageBgSize: convertCfBackgroundSize(imageBgSize),
    reverse,
    children,
    ...convertCfBackgroundProps(doubleContentStyle?.background),
    ...convertCfAlignItemsProps(doubleContentStyle?.alignItems),
    ...convertCfJustifyContentProps(doubleContentStyle?.justifyContent),
    ...convertCfSpacersProps(doubleContentStyle?.spacers),
  };
};

const CfDoubleContentBgBlock = (props: CfDoubleContentBgBlockProps) => (
  <DoubleContentBgBlock {...convertCfDoubleContentBgBlockProps(props)} />
);

export default CfDoubleContentBgBlock;
